// src/slices/price/reducer.js
import { createSlice } from "@reduxjs/toolkit";
import { getAnimalPrices } from "./thunk";

const initialState = {
  loading: false,

  animalPrices: [],
  pagination: null,

  animalPricesByEndpoint: {},

  error: null
};

const animalPriceSlice = createSlice({
  name: "animalPrice",
  initialState,
  reducers: {
    clearAnimalPrices: (state) => {
      state.animalPrices = [];
      state.pagination = null;
      state.animalPricesByEndpoint = {};
      state.error = null;
    }
  },

  extraReducers: (builder) => {
    builder
      .addCase(getAnimalPrices.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(getAnimalPrices.fulfilled, (state, action) => {
        state.loading = false;

        const endpoint = action.payload.endpoint;
        const responseJson = action.payload.data?.data || {};
        const data = responseJson.data || [];
        const pagination = responseJson.pagination || responseJson.responseDetails?.pagination || null;

        state.animalPrices = data;
        state.pagination = pagination;

        state.animalPricesByEndpoint[endpoint] = data;
      })

      .addCase(getAnimalPrices.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { clearAnimalPrices } = animalPriceSlice.actions;

export default animalPriceSlice.reducer;
